module.exports = __webpack_public_path__ + "img/calendar-day-fill.5c3cde0a.svg";